// extracted by mini-css-extract-plugin
export var completionBody = "_c7-2";
export var completionCard = "_c7-0";
export var completionFooter = "_c7-3";
export var completionTitle = "_c7-1";